module.exports = __webpack_public_path__ + "img/pkg-num.442da935.svg";